import { render, staticRenderFns } from "./TaskFiles.vue?vue&type=template&id=c1c3521e&"
import script from "./TaskFiles.vue?vue&type=script&lang=js&"
export * from "./TaskFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports